module.exports = __webpack_public_path__ + "img/726.424279f2.png";